var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoPanoramicCornerWindowsNew({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.2,
    height: 24.2,
    viewBox: "0 0 24.2 24.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "noun-window-7827192",
    d: "M136.118,111.19H112.973a.426.426,0,0,0-.427.426v23.148a.427.427,0,0,0,.427.426h23.146a.426.426,0,0,0,.427-.426V111.616a.427.427,0,0,0-.427-.426Zm-.427,23.148H113.4v-22.3h22.293Zm-21.013-.85h19.733a.426.426,0,0,0,.427-.426V113.349a.427.427,0,0,0-.427-.426H114.678a.426.426,0,0,0-.427.426v19.714a.427.427,0,0,0,.427.426Zm9.44-11.117v-8.6h.853v8.6a.427.427,0,0,0,.427.426h8.586v.85H125.4a.426.426,0,0,0-.427.426v8.565h-.853v-8.565a.427.427,0,0,0-.427-.426H115.1v-.85h8.586A.426.426,0,0,0,124.118,122.371ZM115.1,124.5h8.161v8.139H115.1Zm10.72,8.139V124.5h8.161v8.139Zm8.161-10.692h-8.161v-8.17h8.161Zm-10.72-8.17v8.17H115.1v-8.17Zm-6.922,2.921a.426.426,0,0,1,0-.6l1.13-1.128a.426.426,0,0,1,.6.6l-1.13,1.128A.427.427,0,0,1,116.344,116.7Zm.643,1.631,2.725-2.718a.426.426,0,0,1,.6.6l-2.725,2.718a.426.426,0,0,1-.6-.6Zm10.575,8.955a.426.426,0,1,1-.6-.6l1.131-1.128a.426.426,0,0,1,.6.6l-1.131,1.128Zm3.368-1.087a.426.426,0,0,1,0,.6l-2.725,2.718a.426.426,0,1,1-.6-.6l2.725-2.718a.428.428,0,0,1,.6,0Z",
    transform: "translate(-112.446 -111.09)",
    fill: "#1d1d1f",
    stroke: "#1d1d1f",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPanoramicCornerWindowsNew);
export default __webpack_public_path__ + "static/media/icoPanoramicCornerWindowsNew.4bd54213d2042177da7ecb06df635bee.svg";
export { ForwardRef as ReactComponent };